import { Component, input, ChangeDetectionStrategy } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'

export type StatusChipVariant = 'ok' | 'warn' | 'error' | 'neutral' | 'waiting' | 'primary' | 'secondary'
export type StatusChipMarkerVariant = 'closed' | 'open' | 'none'

@Component({
  selector: 'lib-status-chip',
  imports: [MatIconModule],
  templateUrl: './status-chip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './status-chip.component.scss',
})
export class StatusChipComponent {
  readonly variant = input<StatusChipVariant>()
  readonly markerVariant = input<StatusChipMarkerVariant>('open')

  readonly colors = input<{
    backgroundColor: string
    foregroundColor: string
    textColor: string
  }>()
}
